<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <div
          class="d-flex justify-content-between align-items-md-center align-items-start flex-md-row flex-column mb-2"
        >
          <piaf-breadcrumb :heading="$t('menu.list')" />

          <router-link to="/admin/delivery-terms/create" class="btn btn-primary top-right-button">
            {{ $t('buttons.addNew') }}
          </router-link>
        </div>

        <div class="separator mb-5" />
      </b-colxx>
    </b-row>

    <template v-if="isLoading">
      <div class="loading"></div>
    </template>

    <template v-else>
      <data-list-item :deliveryTerms="deliveryTerms" @update="fetchDeliveryTerms" />
    </template>
  </div>
</template>

<script>
import DataListItem from '@/components/Pages/DeliveryTerms/DataList.vue'
import { handleArrayDataInternalization } from '@/utils'

export default {
  components: {
    'data-list-item': DataListItem
  },
  computed: {
    deliveryTerms() {
      const deliveryTerms = this.$store.getters['deliveryTerms/deliveryTerms']
      return handleArrayDataInternalization(deliveryTerms, ['city', 'term'], this.$i18n.locale)
    },
    isLoading() {
      return this.$store.getters['deliveryTerms/isLoading']
    }
  },
  mounted() {
    this.fetchDeliveryTerms()
  },
  methods: {
    fetchDeliveryTerms() {
      this.$store.dispatch('deliveryTerms/fetchDeliveryTerms')
    }
  }
}
</script>
